import React from "react";
import PropTypes from "prop-types";
import { Field, useForm } from "react-final-form";

import { composeValidators, mustBeNumber } from "./Validation";

const ZipCodeField = ({ name, validate, ...rest }) => {
  const {
    mutators: { setFieldData },
  } = useForm();

  const handleZipCodeKeyDown = (e) => {
    if (
      e.key === "e" ||
      e.key === "E" ||
      (e.target.value &&
        e.target.value.length >= 5 &&
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight" &&
        e.key !== "Tab" &&
        document.getSelection().type !== "Range")
    ) {
      e.preventDefault();
      if (e.target.value.length !== 5) {
        setFieldData(name, {
          warning: "Zip code must be a 5 digit number",
        });
      }
      e.target.classList.add("error-shake");
      setTimeout(() => e.target.classList.remove("error-shake"), 500);
    } else {
      if (Number.isNaN(parseInt(e.key, 10)) && e.key.length === 1) {
        e.target.classList.add("error-shake");
        setTimeout(() => e.target.classList.remove("error-shake"), 500);
      }
      setFieldData(name, {
        warning: undefined,
      });
    }
  };

  return (
    <Field
      name={name}
      validate={composeValidators(validate, mustBeNumber)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {({ input }) => (
        <input
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...input}
          placeholder="Enter a ZIP code"
          className="input"
          pattern="\d{5}"
          maxLength="5"
          min="1"
          type="text"
          onKeyDown={handleZipCodeKeyDown}
        />
      )}
    </Field>
  );
};

ZipCodeField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
};

ZipCodeField.defaultProps = {
  validate: () => undefined,
};

export default ZipCodeField;
